import React from 'react';

//components
import { IconLibrary } from '../../../interfaces/global/icon/IconLibrary';
import Icon from '../icons/Icon';

//styles
import "../../../styles/global/buttons/close-button.scss";


const CloseButton = ({ ariaLabel, onButtonClick}: {ariaLabel: string, onButtonClick: ()=>void}) => {
    return (
        <button
            className='close-button'
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type={'button'}
        >
            <Icon iconName={IconLibrary.CLOSE}  sizeInPx='10' color='var(--thriveLightSlate)'/>
        </button>
    );
};

export default CloseButton